export default __webpack_public_path__ + "static/media/course_ranking.a0a350a5.png";